import EmailVerified from './EmailVerified';

export default EmailVerified;